// extracted by mini-css-extract-plugin
module.exports = {"comp":"Screen5V2_comp__nKbCP"};